export const SEARCH_FETCH = 'SEARCH_FETCH';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const RESET_SEARCH = 'RESET_SEARCH';

export const requestSearch = (query) => {
	return {
		type: SEARCH_FETCH,
		query
	};
}

export const receiveSearch = (query, data) => {
	return {
		type: SEARCH_SUCCESS,
		query,
		data
	};
}

export const failedSearch = (query, error) => {
	return {
		type: SEARCH_FAILURE,
		query,
		error
	};
}

export const resetSearch = ()=> {
	return {
		type: RESET_SEARCH
	};
}



// WEBPACK FOOTER //
// ./common/actions/SearchResultActions.js